import * as React from "react";
import { Grid, Button } from "components/controls/widget";
import { MemberApplication, MemberApplicationState, CzechNamingOfMemberApplicationState } from "../entity";
import { useApplicationList, ContentPage } from "./store";
import DataGrid, { Column, DataGridProps } from "components/controls/DataGrid";
import PageTitle from "common/admin/PageTitle";
import PageContainer from "common/admin/PageContainer";
import PageContent from "common/admin/PageContent";
import SearchInput from "common/admin/SearchInput";

const Content = () => {

    let [state, actions] = useApplicationList();

    const renderState = (col: Column<MemberApplication>, row?: MemberApplication) => {
        return CzechNamingOfMemberApplicationState(row.state);
    }

    const renderButtons = (col: Column<MemberApplication>, row?: MemberApplication) => {

        const showStorno = false;// row.state == MemberApplicationState.BeingEdited || row.state == MemberApplicationState.Submitted
        const showEdit = row.state == MemberApplicationState.BeingEdited;
        const showDetail = row.state != MemberApplicationState.BeingEdited && row.state != MemberApplicationState.Cancelled;

        return <Grid container wrap="nowrap" spacing={8}>
            {showEdit && <Grid item>
                <Button variant="contained" size="small" onClick={() => actions.goToPage(ContentPage.Edit, row.id)}>{'Upravit'}</Button>
            </Grid>}
            {showDetail && <Grid item>
                <Button variant="contained" size="small" onClick={() => actions.goToPage(ContentPage.Detail, row.id)}>{'Detail'}</Button>
            </Grid>}
            {showStorno && <Grid item><Button variant="contained" size="small" onClick={() => actions.deleteAppl(row)}>{'Storno'}</Button>
            </Grid>}
        </Grid>
    }

    const columns = [
        { headerText: "ID", field: "applicationNumber", width: 80 },
        { headerText: "Email", field: "member.email", width: 170 },
        { headerText: "Příjmení", field: "member.surname", width: 200 },
        { headerText: "Jméno", field: "member.name", width: 150 },
        { headerText: "Dat. naroz.", field: "member.birthDate", width: 80, type: 'date', format: 'DD.MM.YYYY' },
        { headerText: "Stav", field: "_stav", width: 80, render: renderState },
        { headerText: "", field: "_buttons", width: 150, render: renderButtons },
    ];

    const dgProps: DataGridProps<MemberApplication> = {
        dataSource: state.dataSource,
        columns: columns,
        paginationSettings: {
            pageCount: 5,
            autoHide: true,
        },
        allowPaging: true,
        allowResizing: true,
        allowSorting: true,
        padding: 'dense',
        showBorder: false,
    }

    return <Grid container spacing={24}>
        <Grid item>
            <Button variant="contained" color="primary" onClick={() => actions.goToPage(ContentPage.Edit)}>{'Vytvořit novou přihlášku'}</Button>
        </Grid>
        <Grid item sm={12}>
            <SearchInput onChanged={actions.onSearchChanged} />
        </Grid>
        <Grid item sm={12}>
            <DataGrid {...dgProps} key={new Date().valueOf()} />
        </Grid>
    </Grid>
}


const View = () => {
    let [state, actions] = useApplicationList();

    React.useEffect(() => {
        actions.initDataSource();
        actions.setActions(actions);
        actions.loadData();
    }, []);

    React.useEffect(() => {
        if (state.page == ContentPage.List) {
            actions.loadData();
        }
    }, [state.page]);

    React.useEffect(() => {
        if (state.needRefresh) {
            actions.loadData();
        }
    }, [state.needRefresh]);

    const showContent = state.dataSource != null;

    return <PageContainer>
        <PageTitle title="Seznam přihlášek členů" />
        <PageContent>
            {showContent && <Content />}
        </PageContent>
    </PageContainer>;
}

export {
    View as ListView
}